const CHUNK_SIZE = 0x8000; // 32KB

// Utility function to safely convert binary data to base64
export const arrayBufferToBase64 = (buffer: Uint8Array): string => {
    let binary = "";

    for (let i = 0; i < buffer.length; i += CHUNK_SIZE) {
        binary += String.fromCharCode(...buffer.subarray(i, i + CHUNK_SIZE));
    }

    return btoa(binary);
};

export const base64ToArrayBuffer = (base64: string) => {
    try {
        const binaryString = atob(base64);

        const length = binaryString.length;
        const uint8Array = new Uint8Array(length);
        for (let i = 0; i < length; i++) {
            uint8Array[i] = binaryString.charCodeAt(i);
        }

        return uint8Array;
    } catch (error) {
        throw new Error(`Failed to convert Base64 to ArrayBuffer: ${error}`);
    }
};
